import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import iconsType from "../images/iconsType.svg";
import iconsStage from "../images/iconsStage.svg";
import iconsLocation from "../images/iconsLocation.svg";
import iconsIndustry from "../images/iconsIndustry.svg";
import { useAuth } from "../contexts/AuthContext";

function GetItem(props) {
  const { page } = props;
  switch (page + 1) {
    case 1:
      return (
        <div>
          <div style={{ fontSize: "72px", lineHeight: "84px" }}>10000+</div>
          <div
            style={{
              fontSize: "18px",
              lineHeight: "21px",
            }}
          >
            The largest directory of incubators, accelerators and angel
            investors
          </div>
        </div>
      );
    case 2:
      return (
        <div>
          <div style={{ fontSize: "24px", lineHeight: "28px" }}>
            Filter the investors based on:{" "}
          </div>
          <br></br>
          <span style={{ fontStyle: "normal", fontWeight: "normal" }}>
            <img
              style={{ width: "18px", height: "22px" }}
              src={iconsLocation}
            />
            &emsp;Location &emsp;&emsp;&emsp;{" "}
            <img style={{ width: "22px", height: "18px" }} src={iconsType} />
            &emsp;Type<br></br>
            <br></br>
            <img
              style={{ width: "22px", height: "18px" }}
              src={iconsIndustry}
            />
            &emsp;Industry &emsp;&emsp;&emsp;{" "}
            <img style={{ width: "22px", height: "12px" }} src={iconsStage} />
            &emsp;Stage
          </span>
        </div>
      );
    case 3:
      return (
        <div>
          <div style={{ fontSize: "24px", lineHeight: "28px" }}>
            Bookmark your interests
          </div>
          <span
            style={{
              fontSize: "16px",
              lineHeight: "19px",
              fontStyle: "normal",
              fontWeight: "normal",
            }}
          >
            you can contact them when you’re ready
          </span>
        </div>
      );
    default:
      return "";
  }
}

function WaitlistPage(props) {
  const { imgSrc, num } = props;
  const history = useHistory();
  const { subscribed } = useAuth();
  const getInvested = (subscribed) => {
    if (subscribed === 1) {
      history.push("/dashboard");
      return <Redirect to="/dashboard" />;
    } else {
      history.push("/prices");
      return <Redirect to="/prices" />;
    }
  };
  useEffect(() => {
    document.documentElement.style.setProperty("--background", "#fff");
    return history.listen((location) => {
      if (location.action === "POP") {
        history.goBack();
      }
    });
  }, []);
  return (
    <React.Fragment>
      <div className="left-side-text-wrapper">
        <GetItem page={num} />
      </div>
      <div className="button-wrapper">
        <button
          className="join-waitlist-button"
          onClick={() => getInvested(subscribed)}
        >
          {subscribed === 1 ? "Go To Dashboard" : "Get Invested"}
        </button>
      </div>
      <div className="image-wrapper">
        <img alt="" src={imgSrc} />
      </div>
    </React.Fragment>
  );
}

WaitlistPage.propTypes = {};

export default WaitlistPage;
